module.exports = function(service) {
	'use strict'
	service.factory('keyPressOnlyNumber', keyPressOnlyNumber);
	keyPressOnlyNumber.$inject = [];
	function keyPressOnlyNumber() {
	   return function(evt) {
			evt = (evt) ? evt : event;
		    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
		    ((evt.which) ? evt.which : 0));
		    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		        evt.preventDefault();
		    }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/keyPressOnlyNumberService.js
// module id = 614
// module chunks = 0